(function () {
  // prova a ricavare il section.id dal <template>
  var tpl = document.querySelector('[id^="variant-retro-compat-map-"]');
  if (!tpl) return;
  var secId = tpl.id.replace('variant-retro-compat-map-', '');

  // leggi mappa variantId -> array retro-compat
  var json = tpl.innerHTML || tpl.textContent || '{}';
  var rcMap = {};
  try { rcMap = JSON.parse(json) || {}; } catch (e) { rcMap = {}; }

  var rowEl  = document.getElementById('retro-compat-row-' + secId);
  var listEl = document.getElementById('retro-compat-list-' + secId);
  if (!rowEl || !listEl) return;

  function normalizeToArray(val) {
    // gestisce null, stringhe singole, array
    if (val == null) return [];
    if (Array.isArray(val)) return val.filter(function (x) { return String(x).trim() !== ''; });
    var s = String(val).trim();
    return s ? [s] : [];
  }

  function setRetroCompat(variantId) {
    var val = rcMap[String(variantId)];
    var items = normalizeToArray(val);

    // pulisci la lista
    while (listEl.firstChild) listEl.removeChild(listEl.firstChild);

    if (!items.length) {
      rowEl.style.display = 'none';
      return;
    }

    rowEl.style.display = '';
    items.forEach(function (txt) {
      var li = document.createElement('li');
      li.className = 'retro-compat-item';
      li.textContent = txt; // evita HTML injection
      listEl.appendChild(li);
    });
  }

  // 1) evento nativo dei temi moderni (Split/Dawn)
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && v.id) setRetroCompat(v.id);
  });

  // 2) fallback: ascolta cambi nel form varianti
  var form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('change', function () {
      var idInput = form.querySelector('input[name="id"]');
      var select  = form.querySelector('select[name="id"]');
      var variantId = (idInput && idInput.value) || (select && select.value);
      if (variantId) setRetroCompat(variantId);
    });

    new MutationObserver(function () {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput && idInput.value) setRetroCompat(idInput.value);
    }).observe(form, { subtree: true, childList: true });
  }

  // 3) init con la variante corrente
  (function () {
    var initialId = null;
    if (form) {
      var idInput = form.querySelector('input[name="id"]');
      var select  = form.querySelector('select[name="id"]');
      initialId = (idInput && idInput.value) || (select && select.value);
    }
    if (!initialId) {
      var keys = Object.keys(rcMap);
      if (keys.length) initialId = keys[0];
    }
    if (initialId) setRetroCompat(initialId);
  })();
})();
